import NotificationManager from 'react-hot-toast';
// Toast
export const Toast = ({ type = 'success', message, duration = 1000 }) => {
  if (typeof window === 'undefined') return;

  if (Array.isArray(message)) {
    let item;

    for (item of message) {
      NotificationManager[type](item.message, { duration });
    }
  } else {
    NotificationManager[type](message, { duration });
  }
};
